<template>
  <v-container
    class="chapter-page px-0 pt-12 pb-0 pt-sm-0"
    fluid
    v-if="chapter"
    v-scroll="onScroll"
    ref="container"
    >
    <TextRow
      :chapterTitle="chapter.title"
      :chapterSubtitle="chapter.introQuoteSubtitle"
      :chapterID="chapterId"
      :text="chapter.introQuoteContent"
      id="chapter-0"
      class="observe-intersect"
      data-type="chapter-quote"
      data-page-index="a"
      :data-min-intersect="0.25"
      />

    <v-row v-for="(project, index) in projects" :key="index">
      <v-col>

        <div
          v-if="project.heroImage"
          class="observe-intersect project-hero"
          data-type="project-hero"
          :style="getHeroImageStyle(`b-${index.toString().padStart(projects.length.toString().length, '0')}-a`, `b-${index.toString().padStart(projects.length.toString().length, '0')}-b`)"
          :data-project-index="index"
          :data-page-index="`b-${index.toString().padStart(projects.length.toString().length, '0')}-a`"
          :data-min-intersect="0.25"
          >
          <seo-v-img class="img" width="100%" height="100vh" position="center bottom" :src="'/media/'+project.heroImage.id" cover />
        </div>

        <ChapterProjectHeading
          :chapterId="chapterId"
          :projectIndex="index + 1"
          :data="project"
          :id="'chapter-' + (index + 1)"
          class="observe-intersect"
          data-type="project-heading"
          :data-project-index="index"
          :data-page-index=" `b-${index.toString().padStart(projects.length.toString().length, '0')}-b`"
        />

        <v-row v-for="(content, c) in project.content" :key="`b-${index.toString().padStart(projects.length.toString().length, '0')}-c-${c.toString().padStart(project.content.length.toString().length, '0')}`" no-gutters class="project-content-container">

          <div v-if="content._repeaterType === 'Vertical Images'" class="content-gallery">
            <v-row
              v-for="(image, im) in content.gallery"
              :key="`b-${index.toString().padStart(projects.length.toString().length, '0')}-c-${c.toString().padStart(project.content.length.toString().length, '0')}-${im.toString().padStart(content.gallery.length.toString().length, '0')}`"
              align="center"
              justify="center"
              class="ma-0 project-image observe-intersect"
              data-type="project-vertical-image"
              :data-project-index="index"
              :data-content-index="c"
              :data-image-index="im"
              :data-page-index=" `b-${index.toString().padStart(projects.length.toString().length, '0')}-c-${c.toString().padStart(project.content.length.toString().length, '0')}-${im.toString().padStart(content.gallery.length.toString().length, '0')}`"
              >
              <v-responsive
                :aspect="getAspect(image.image)"
                height="100vh"
                />
                <!-- :style="{backgroundImage: `url(${JSON.parse(image.image.metaData)['image-lazy-src']})`}" -->
            </v-row>
          </div>

          <div
            v-else-if="content._repeaterType === 'Horizontal Images'"
            class="content-gallery observe-intersect"
            :id=" `b-${index.toString().padStart(projects.length.toString().length, '0')}-c-${c.toString().padStart(project.content.length.toString().length, '0')}`"
            :data-page-index=" `b-${index.toString().padStart(projects.length.toString().length, '0')}-c-${c.toString().padStart(project.content.length.toString().length, '0')}`"
            data-type="project-horizontal-gallery"
            :data-project-index="index"
            :data-content-index="c"
            :data-min-intersect="0.001"
            >
            <v-row
              v-for="(image, im) in content.gallery"
              :key="`b-${index.toString().padStart(projects.length.toString().length, '0')}-c-${c.toString().padStart(project.content.length.toString().length, '0')}-${im.toString().padStart(content.gallery.length.toString().length, '0')}`"
              align="center"
              justify="center"
              class="ma-0 project-image"
              >
              <v-responsive
                :aspect="getAspect(image.image)"
                height="100vh"
                />
                <!-- :style="{backgroundImage: `url(${JSON.parse(image.image.metaData)['image-lazy-src']})`}" -->
            </v-row>
          </div>

          <v-col
            v-else-if="content._repeaterType === 'Text Paragraph'"
            class="px-6 my-12 observe-intersect project-text"
            cols="12"
            md="10"
            :style="{minHeight: '120vh'}"
            offset-md="1"
            :key="`b-${index.toString().padStart(projects.length.toString().length, '0')}-c-${c.toString().padStart(project.content.length.toString().length, '0')}`"
            data-type="project-text"
            :data-project-index="index"
            :data-content-index="c"
            :data-min-intersect="0.01"
            :data-page-index="`b-${index.toString().padStart(projects.length.toString().length, '0')}-c-${c.toString().padStart(project.content.length.toString().length, '0')}`"
            >
            <v-row no-gutters justify="center" align="center" class="fill-height">
              <v-col >
                <v-row class="sticky-row mobile-center-row" justify="start" >
                  <v-col cols="10" md="5" class="pr-md-6 project-text-right-column" :style="getTextRightColumnStyle(`b-${index.toString().padStart(projects.length.toString().length, '0')}-c-${c.toString().padStart(project.content.length.toString().length, '0')}`)" >
                    <h5 class="mb-2">{{content.Subtitle}}</h5>
                    <h2>{{content.Title}}</h2>
                    <p class="mt-5 mb-5">{{content.Author}}</p>
                  </v-col>
                </v-row>
                <v-row class="mobile-center-row" justify="end" align="end" >
                  <v-col cols="10" md="7" class="pl-md-12">
                    <MarkdownBlock :inline="false" :linkify="true" tag="div" class="project-text-paragraph" :text="content.Body" />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>

          <v-col
            cols="12"
            v-else-if="content._repeaterType === 'Vimeo Video'"
            :key="`b-${index.toString().padStart(projects.length.toString().length, '0')}-c-${c.toString().padStart(project.content.length.toString().length, '0')}`"
            class="observe-intersect"
            data-type="project-video"
            :data-project-index="index"
            :data-content-index="c"
            :data-min-intersect="0.25"
            :data-page-index="`b-${index.toString().padStart(projects.length.toString().length, '0')}-c-${c.toString().padStart(project.content.length.toString().length, '0')}`"
            >
            <vimeo-player
              ref="player"
              class="d-block fade-in-img my-auto"
              :video-id="content.link"
              :player-width="viewPort.width"
              :player-height="viewPort.height / 100 * 85"
            />
          </v-col>
        </v-row>

      </v-col>
    </v-row>

    <ChapterSocial
      v-if="!$root.platform.prerenderer && currentChapter.socials && currentChapter.socials.length > 0"
      id="section-social"
      class="observe-intersect"
      :data="currentChapter.socials"
      data-type="chapter-social"
      :data-min-intersect="0.25"
      data-page-index="u"
    />

    <ChapterExtra
      v-if="!$root.platform.prerenderer && chapter.extras && chapter.extras.length > 0"
      id="section-extra"
      class="observe-intersect"
      :data="chapter.extras"
      data-type="chapter-extra"
      :data-min-intersect="0.25"
      data-page-index="v"
    />

    <ChapterNext
      :nextChapterId="nextChapter"
      class="observe-intersect"
      data-type="chapter-next"
      :data-min-intersect="0.25"
      data-page-index="z"
    />
  </v-container>
</template>

<script>
// import { RAF } from '@monogrid/js-utils'
import { Viewport, MarkdownBlock } from '@monogrid/vue-lib'
import GetChapterEN from '@/graphql/GetChapterEN.gql'
import GetChapterIT from '@/graphql/GetChapterIT.gql'
import TextRow from '@/molecules/TextRow'
import ChapterProjectHeading from '@/organisms/ChapterProjectHeading'
import ChapterNext from '@/molecules/ChapterNext'
import ChapterSocial from '@/molecules/ChapterSocial'
import ChapterExtra from '@/molecules/ChapterExtra'
import goTo from 'vuetify/es5/services/goto'
// import throttle from 'lodash/throttle'
import sortBy from 'lodash/sortBy'
import findIndex from 'lodash/findIndex'
import isNil from 'lodash/isNil'

const metadataCache = {}

export default {
  name: 'Chapter',

  mixins: [Viewport],

  components: {
    ChapterNext,
    ChapterSocial,
    ChapterExtra,
    TextRow,
    MarkdownBlock,
    ChapterProjectHeading
  },

  props: {
    chapterId: {
      required: true
    }
  },

  data () {
    return {
      chapterQueries: {
        it: GetChapterIT,
        en: GetChapterEN
      },
      currentChapter: null,
      chapter: null,
      projects: null,
      scrollDirection: 'down',
      // openCaptionID: '',
      scrollToOnLoad: null,
      onScreenElements: [],
      chapterHeight: 0,
      chapterScroll: 0
    }
  },

  apollo: {
    currentChapter: {
      skip () {
        return this.currentChapter && this.currentChapter._slug === 'chapter-' + this.chapterId
      },
      query () {
        this.$root.preloader.visible = true
        this.$root.currentChapterSection = ''
        return this.chapterQueries[this.$route.params.language]
      },
      variables () {
        return {
          status: 'PUBLISHED',
          slug: 'chapter-' + this.chapterId
        }
      },
      result () {
        this.$root.preloader.visible = false
        this.projects = this.currentChapter[this.$route.params.language].projects
        this.chapter = this.currentChapter[this.$route.params.language]
        this.$root.$emit('scroll-to-saved-position')
        if (this.$route.hash) {
          this.scrollToOnLoad = parseFloat(this.$route.hash.split('#')[1])
          if (isNaN(this.scrollToOnLoad) || this.scrollToOnLoad < 0 || this.scrollToOnLoad > this.chapter.projects.length) {
            this.scrollToOnLoad = null
          }
          this.$router.replace({ name: this.$route.name, params: { language: this.$route.params.language } })
        }
        // window.addEventListener('scroll', this.onScroll)
        if (this.scrollToOnLoad) {
          this.scrollToChapter(this.scrollToOnLoad)
          this.scrollToOnLoad = null
        }
        setTimeout(this.observeIntersection, 200)
      }
    }
  },

  created () {
    this.observer = new IntersectionObserver((entries = [], observer) => { // eslint-disable-line
      entries.forEach(e => {
        const minIntersect = isNil(e.target.dataset.minIntersect) ? 0.5 : parseFloat(e.target.dataset.minIntersect)
        this.onElementIntersect({
          type: e.target.dataset.type,
          projectIndex: e.target.dataset.projectIndex,
          contentIndex: e.target.dataset.contentIndex,
          imageIndex: e.target.dataset.imageIndex,
          pageIndex: e.target.dataset.pageIndex
        }, e.isIntersecting, e.intersectionRatio, minIntersect)
      })
    }, {
      threshold: [0, 0.01, 0.1, 0.25, 0.5, 0.75, 0.9, 0.99, 1]
    })
  },

  updated () {
    this.observeIntersection()
  },

  mounted () {
    this.$root.currentChapterSection = ''
    this.$events.on('chapter-scroll-to', ({ id, slug }) => {
      if (this.currentChapter && this.currentChapter._slug === slug) {
        this.scrollToChapter(id)
      } else {
        this.scrollToOnLoad = id
      }
    })
  },

  beforeDestroy () {
    this.$events.off('chapter-scroll-to')
    this.$events.emit('full-screen-element', null)
    this.$root.currentChapterSection = ''
  },

  watch: {
    onScreenElements (value) {
      const lastValue = value[value.length - 1]
      if (lastValue) {
        switch (lastValue.type) {
          case 'project-horizontal-gallery':
            this.$events.emit('full-screen-element', lastValue)
            break
          case 'project-vertical-image':
            this.$events.emit('full-screen-element', lastValue)
            break
          default:
            this.$events.emit('full-screen-element', null)
        }
      }
      if (lastValue.type === 'chapter-extra' || lastValue.type === 'chapter-social' || lastValue.type === 'chapter-next' || lastValue.type === 'chapter-quote') {
        this.$root.currentChapterSection = lastValue.type
      } else {
        this.$root.currentChapterSection = 'project-' + lastValue.projectIndex
      }
    }
  },

  methods: {
    observeIntersection () {
      if (this.observer) {
        const elements = this.$el.querySelectorAll('.observe-intersect')
        for (let i = 0; i < elements.length; i++) {
          this.observer.observe(elements[i])
        }
      }
    },
    getHeroImageStyle (id, headingId) {
      const elemIndex = findIndex(this.onScreenElements, (e) => e.pageIndex === id)
      const headingElemIndex = findIndex(this.onScreenElements, (e) => e.pageIndex === headingId)

      if (headingElemIndex !== -1 || elemIndex !== -1) {
        // header or hero image are on screen
        const lastOnScreenElement = this.onScreenElements.lastItem
        const element = this.onScreenElements[elemIndex]
        const headingElement = this.onScreenElements[headingElemIndex]

        const sortedElements = sortBy([lastOnScreenElement, headingElement || { pageIndex: 'a' }, element || { pageIndex: 'a' }], ['pageIndex'])

        if (sortedElements[sortedElements.length - 1] === headingElement || sortedElements[sortedElements.length - 1] === element) {
          // heading OR hero image is the last element on screen, we didn't scroll past it
          return {
            opacity: headingElement ? 0.2 : 1
          }
        }
      }

      return {
        opacity: 0
      }
    },
    getTextRightColumnStyle (id) {
      const elemIndex = findIndex(this.onScreenElements, (e) => e.pageIndex === id)

      if (this.$vuetify.breakpoint.mdAndUp) {
        if (elemIndex !== -1) {
          const lastOnScreenElement = this.onScreenElements.lastItem
          const element = this.onScreenElements[elemIndex]

          const sortedElements = sortBy([lastOnScreenElement, element || { pageIndex: 'a' }], ['pageIndex'])

          if (sortedElements[sortedElements.length - 1] === element) {
            return {
              opacity: 1
            }
          }
        }

        return { opacity: 0 }
      }
      return {
        opacity: 1
      }
    },
    onElementIntersect (element, isIntersecting, intersectionRatio, minRatio) {
      element = JSON.parse(JSON.stringify(element)) // clone
      // const elemString = JSON.stringify(element)
      const elemIndex = findIndex(this.onScreenElements, (e) => e.pageIndex === element.pageIndex)

      // if (elemIndex !== -1) {
      //   this.onScreenElements[elemIndex].intersectionRatio = intersectionRatio
      // }

      if (isIntersecting && intersectionRatio >= minRatio) {
        if (elemIndex === -1) {
          // element.intersectionRatio = intersectionRatio
          element.chapter = this.chapter
          element.startScroll = this.chapterScroll
          element.startDirection = this.scrollDirection
          const htmlElement = this.$el.querySelector(`#${element.pageIndex}`)
          if (htmlElement) {
            element.height = htmlElement.getBoundingClientRect().height
          }
          // console.log('adding', element)
          this.onScreenElements.push(element)
        }
      } else if (intersectionRatio < minRatio) {
        if (elemIndex !== -1) {
          // console.log('removing', element)
          this.onScreenElements.splice(elemIndex, 1)
        }
      }
      this.onScreenElements = sortBy(this.onScreenElements, ['pageIndex'])
    },
    onScroll (e) {
      if (this.$refs.container) {
        const prevChapterScroll = this.chapterScroll
        const domRect = this.$refs.container.getBoundingClientRect()
        this.chapterHeight = domRect.height
        this.chapterScroll = (domRect.top * -1)
        this.$root.chapterProgress = (this.chapterScroll / domRect.height) * 100
        this.scrollDirection = prevChapterScroll <= this.chapterScroll ? 'down' : 'up'
        this.$events.emit('chapter-scroll', this.chapterScroll)
      }
    },

    scrollToChapter (id) {
      clearTimeout(this.scrollTimeout)
      this.scrollTimeout = setTimeout(() => {
        // vuetify goto here
        goTo('#chapter-' + id, { duration: 350 })
      }, 600)
    },
    getAspect (image) {
      let meta
      if (metadataCache[image.metaData]) {
        meta = metadataCache[image.metaData]
      } else {
        meta = metadataCache[image.metaData] = JSON.parse(image.metaData)
      }
      return meta['image-width'] / meta['image-height']
    }
  },

  computed: {
    nextChapter () {
      if (this.chapterId === this.$root.chapters.length - 1) {
        return 0
      } else {
        return this.chapterId + 1
      }
    }
  },

  // destroyed () {
  //   window.removeEventListener('scroll', this.onScroll)
  // },

  metaInfo: function () {
    if (!this.currentChapter) return null
    return {
      // home page browser title
      title: this.chapter.title,
      meta: [
        // generic description
        { vmid: 'description', name: 'description', content: this.chapter.ogDescription },
        // og tags
        { vmid: 'ogtitle', property: 'og:title', itemprop: 'name', content: this.chapter.title + ' - The COVID-19 Visual Project' },
        { vmid: 'ogdescription', property: 'og:description', content: this.chapter.ogDescription },
        { vmid: 'ogimage', property: 'og:image', content: 'https://' + this.$root.process.env.SERVICE_TARGET_DOMAIN + '/' + this.$root.process.env.MEDIA_PATH + '/' + this.currentChapter.heroImage.id },
        { vmid: 'ogimagetype', property: 'og:image:type', content: 'image/jpeg' },
        { vmid: 'ogimageheight', property: 'og:image:width', content: JSON.parse(this.currentChapter.heroImage.metaData)['image-width'] },
        { vmid: 'ogimagewidth', property: 'og:image:height', content: JSON.parse(this.currentChapter.heroImage.metaData)['image-height'] }
      ]
    }
  }
}
</script>

<style scoped lang="scss">

.sticky-row {
  position: sticky;
  top: 30%;

  @include breakpoint('sm-and-down') {
    position: relative;
    top: 0;
  }
}

.mobile-center-row {
  @include breakpoint('sm-and-down') {
    justify-content: center !important;
  }
}

.chapter-page {
  background-color: $c-gradient-bg;

  height: 100%;
  width: 100%;
}

.content-gallery,
.content-gallery .row {
  position: relative;
  width: 100%;
}

.project-text {
  h2 {
    @include breakpoint('md-only') {
      font-size: 50px;
    }
    @include breakpoint('lg-and-up') {
      font-size: 60px;
    }
  }
}

.project-text-right-column {
  @include breakpoint('md-and-up') {
    // opacity: 0;
    position: sticky;
    top: 50%;
    transition: opacity 0.5s;
  }
}

.project-text-paragraph {
  p {
    font-size: 18px;
  }
}

// .project-content-container {
//   z-index: 0;
//   position: relative;
// }

.project-image {
  // filter: blur(30px);

  .v-responsive {
    // filter: grayscale(100%);
    // opacity: 0.2;
    opacity: 0;
    // background-size: cover;
    // background-position: 50% 50%;
  }
}

.project-hero {
  position: sticky;
  top: 0;
  transition: opacity 0.3s;
  z-index: 1;
  pointer-events: none;
}

// .fixed {
//   position: fixed;
//   top: 0;
// }

// .chapter-spacer {
//   height: 50vh;
//   max-height: 50vh;
//   box-shadow: 0 16px 15px 0 rgba(0, 0, 0, 0.16);
//   background-color: $c-gradient-bg;
//   border-style: none;

//   &.first {
//     margin-top: 100vh;
//   }
// }

</style>
